"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderArticles = exports.renderSearchCard = exports.renderRateTable = exports.renderSchedule = exports.renderRowError = exports.renderError = exports.renderSummary = exports.renderDiagram = exports.renderBreakdown = exports.renderOverviewPayment = exports.renderAffordability = exports.getActiveClass = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var format_1 = require("@/utils/format");
var myokay_donut_1 = require("@okay/myokay-donut");
var errorToString_1 = require("@/pages/mortagage/transformer/errorToString");
exports.getActiveClass = function (tab, currentTab) { return classnames_1.default([
    'c-minitab__item', {
        'c-minitab__item--active': tab === currentTab,
    },
]); };
exports.renderAffordability = function (propertyValue, loanAmount, loanPercent, t) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "c-mortgage__affordability" },
            React.createElement("div", { className: "c-mortgage__head" }, t.highestAffordableProperty),
            React.createElement("div", { className: "c-mortgage__blocks" },
                React.createElement("div", { className: "c-mortgage__block c-mortgage__block--lg" },
                    React.createElement("div", { className: "c-mortgage__block-title" }, t.propertyValue),
                    React.createElement("div", { className: "c-mortgage__block-value" },
                        React.createElement("span", { className: "c-mortgage__block-unit c-mortgage__block-unit--prefix" }, t.hkd),
                        format_1.default.currencyFull(Math.ceil(propertyValue)))))),
        React.createElement("div", { className: "c-mortgage__affordability" },
            React.createElement("div", { className: "c-mortgage__head" }, t.mortgage),
            React.createElement("div", { className: "c-mortgage__blocks" },
                React.createElement("div", { className: "c-mortgage__block c-mortgage__block--lg" },
                    React.createElement("div", { className: "c-mortgage__block-title" }, t.loanAmount),
                    React.createElement("div", { className: "c-mortgage__block-value" },
                        React.createElement("span", { className: "c-mortgage__block-unit c-mortgage__block-unit--prefix" }, t.hkd),
                        format_1.default.currencyFull(Math.ceil(loanAmount)))),
                React.createElement("div", { className: "c-mortgage__block" },
                    React.createElement("div", { className: "c-mortgage__block-title" }, t.loanPercentage),
                    React.createElement("div", { className: "c-mortgage__block-value" },
                        loanPercent,
                        React.createElement("span", { className: "c-mortgage__block-unit" }, "%")))))));
};
exports.renderOverviewPayment = function (monthlyPayment, minimumIncome, t) {
    return (React.createElement("div", { className: "c-mortgage__payment" },
        React.createElement("div", { className: "c-mortgage__head" }, t.monthlyPayment),
        React.createElement("div", { className: "c-mortgage__blocks" },
            React.createElement("div", { className: "c-mortgage__block c-mortgage__block--lg" },
                React.createElement("div", { className: "c-mortgage__block-title" }, t.monthlyPayment),
                React.createElement("div", { className: "c-mortgage__block-value" },
                    React.createElement("span", { className: "c-mortgage__block-unit c-mortgage__block-unit--prefix" }, t.hkd),
                    format_1.default.currencyFull(Math.ceil(monthlyPayment)))),
            minimumIncome ? (React.createElement("div", { className: "c-mortgage__block" },
                React.createElement("div", { className: "c-mortgage__block-title" }, t.minimumIncome),
                React.createElement("div", { className: "c-mortgage__block-value" },
                    React.createElement("span", { className: "c-mortgage__block-unit c-mortgage__block-unit--prefix" }, t.hkd),
                    format_1.default.currencyFull(Math.ceil(minimumIncome))))) : null)));
};
exports.renderBreakdown = function (totalExpenses, totalCashOutlay, t) {
    return (React.createElement("div", { className: "c-mortgage__breakdown" },
        React.createElement("div", { className: "c-mortgage__head" }, t.totalExpensesBreakdown),
        React.createElement("div", { className: "c-mortgage__blocks" },
            React.createElement("div", { className: "c-mortgage__block c-mortgage__block--lg" },
                React.createElement("div", { className: "c-mortgage__block-title" }, t.totalExpenses),
                React.createElement("div", { className: "c-mortgage__block-value" },
                    React.createElement("span", { className: "c-mortgage__block-unit c-mortgage__block-unit--prefix" }, t.hkd),
                    format_1.default.currencyFull(Math.ceil(totalExpenses)))),
            React.createElement("div", { className: "c-mortgage__block" },
                React.createElement("div", { className: "c-mortgage__block-title" }, t.totalCashOutlay),
                React.createElement("div", { className: "c-mortgage__block-value" },
                    React.createElement("span", { className: "c-mortgage__block-unit c-mortgage__block-unit--prefix" }, t.hkd),
                    format_1.default.currencyFull(Math.ceil(totalCashOutlay)))))));
};
exports.renderDiagram = function (loanAmount, downPayment, totalInterest, isInsuranceMonthlyRepay, insuranceInitial, insurance, totalTax, commission, legalAmount, totalExpenses, t) {
    var donutState = {
        items: [
            { name: t.downPayment, color: 'orange', value: downPayment },
            { name: isInsuranceMonthlyRepay ? t.totalMortgage : t.mortgage, color: 'yellow', value: loanAmount },
            { name: t.interest, color: 'green', value: totalInterest },
            { name: t.insurance, color: 'purple', value: insuranceInitial },
            { name: t.stampDuty, color: 'cyan', value: totalTax },
            { name: t.commission, color: 'blue', value: commission },
            { name: t.legal, color: 'red', value: legalAmount },
        ].filter(function (it) { return it.value > 0; }).map(function (it) { return (__assign(__assign({}, it), { valueText: format_1.default.currency(Math.ceil(it.value)) })); }),
        value: format_1.default.currency(Math.ceil(totalExpenses)),
        unit: "" + t.hkd,
        caption: t.totalExpenses,
    };
    return (React.createElement("div", { className: "c-mortgage__diagram l-pad l-pad--2" },
        React.createElement("div", { className: "c-mortgage__cals" },
            React.createElement("div", { className: "c-mortgage__table" },
                React.createElement("div", { className: "c-mortgage__calrows" },
                    React.createElement("div", { className: "c-mortgage__calrow" },
                        React.createElement("div", { className: "c-mortgage__callabel" },
                            React.createElement("span", { style: { backgroundColor: 'orange' }, className: "c-mortgage__bulb" }),
                            t.downPayment),
                        React.createElement("div", { className: "c-mortgage__calvalue" }, format_1.default.currencyFull(Math.ceil(downPayment)))),
                    React.createElement("div", { className: "c-mortgage__calrow" },
                        React.createElement("div", { className: "c-mortgage__callabel" },
                            React.createElement("span", { style: { backgroundColor: 'yellow' }, className: "c-mortgage__bulb" }),
                            isInsuranceMonthlyRepay ? t.totalMortgage : t.mortgage,
                            isInsuranceMonthlyRepay ? (React.createElement("span", { className: "c-forms__info" },
                                React.createElement("span", { style: { textAlign: 'center' }, dangerouslySetInnerHTML: { __html: format_1.default.print(t.totalMortgageHint, [format_1.default.comma(loanAmount - insurance), format_1.default.comma(insurance)]) } }))) : null),
                        React.createElement("div", { className: "c-mortgage__calvalue" }, format_1.default.currencyFull(Math.ceil(loanAmount)))),
                    React.createElement("div", { className: "c-mortgage__calrow" },
                        React.createElement("div", { className: "c-mortgage__callabel" },
                            React.createElement("span", { style: { backgroundColor: 'green' }, className: "c-mortgage__bulb" }),
                            t.interest),
                        React.createElement("div", { className: "c-mortgage__calvalue" }, format_1.default.currencyFull(Math.ceil(totalInterest)))),
                    insuranceInitial ? (React.createElement("div", { className: "c-mortgage__calrow" },
                        React.createElement("div", { className: "c-mortgage__callabel" },
                            React.createElement("span", { style: { backgroundColor: 'purple' }, className: "c-mortgage__bulb" }),
                            t.insurance),
                        React.createElement("div", { className: "c-mortgage__calvalue" }, format_1.default.currencyFull(Math.ceil(insuranceInitial))))) : null,
                    React.createElement("div", { className: "c-mortgage__calrow" },
                        React.createElement("div", { className: "c-mortgage__callabel" },
                            React.createElement("span", { style: { backgroundColor: 'cyan' }, className: "c-mortgage__bulb" }),
                            t.stampDuty),
                        React.createElement("div", { className: "c-mortgage__calvalue" }, format_1.default.currencyFull(Math.ceil(totalTax)))),
                    React.createElement("div", { className: "c-mortgage__calrow" },
                        React.createElement("div", { className: "c-mortgage__callabel" },
                            React.createElement("span", { style: { backgroundColor: 'blue' }, className: "c-mortgage__bulb" }),
                            t.commission),
                        React.createElement("div", { className: "c-mortgage__calvalue" }, format_1.default.currencyFull(Math.ceil(commission)))),
                    React.createElement("div", { className: "c-mortgage__calrow" },
                        React.createElement("div", { className: "c-mortgage__callabel" },
                            React.createElement("span", { style: { backgroundColor: 'red' }, className: "c-mortgage__bulb" }),
                            t.legal),
                        React.createElement("div", { className: "c-mortgage__calvalue" }, format_1.default.currencyFull(Math.ceil(legalAmount))))),
                React.createElement("div", { className: "c-mortgage__caltotal" },
                    React.createElement("div", { className: "c-mortgage__callabel" }, t.total),
                    React.createElement("div", { className: "c-mortgage__calvalue" }, format_1.default.currencyFull(Math.ceil(totalExpenses)))))),
        React.createElement("div", { className: "c-mortgage__graph" },
            React.createElement(myokay_donut_1.Donut, __assign({}, donutState, { onHover: function () { } })))));
};
exports.renderSummary = function (loanAmount, downPayment, monthlyPayment, totalInterest, isInsuranceMonthlyRepay, insurance, totalTax, commission, totalExpenses, totalCashOutlay, legalAmount, t) {
    return (React.createElement("div", { className: "c-mortgage__summary" },
        React.createElement("div", { className: "c-mortgage__head" }, t.mortgageSummary),
        React.createElement("div", { className: "l-pad l-pad--2" },
            React.createElement("table", { className: "c-amortize__table" },
                React.createElement("thead", { className: "c-amortize__head c-amortize__head--light" },
                    React.createElement("tr", null,
                        React.createElement("th", { colSpan: 2 }, t.monthlyExpenses))),
                React.createElement("tbody", { className: "c-amortize__body" },
                    React.createElement("tr", null,
                        React.createElement("th", null, t.monthlyPayment),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(monthlyPayment))))),
                React.createElement("tfoot", { className: "c-amortize__foot" },
                    React.createElement("tr", null,
                        React.createElement("th", null, t.total),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(monthlyPayment))))))),
        React.createElement("div", { className: "l-pad l-pad--2" },
            React.createElement("table", { className: "c-amortize__table l-pad l-pad--2" },
                React.createElement("thead", { className: "c-amortize__head c-amortize__head--light" },
                    React.createElement("tr", null,
                        React.createElement("th", { colSpan: 2 }, t.totalExpenses))),
                React.createElement("tbody", { className: "c-amortize__body" },
                    React.createElement("tr", null,
                        React.createElement("th", null, t.downPayment),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(downPayment)))),
                    React.createElement("tr", null,
                        React.createElement("th", null, isInsuranceMonthlyRepay ? t.totalMortgage : t.mortgage),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(loanAmount)))),
                    React.createElement("tr", null,
                        React.createElement("th", null, t.interest),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(totalInterest)))),
                    insurance ? (React.createElement("tr", null,
                        React.createElement("th", null, t.insurance),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(insurance))))) : null,
                    React.createElement("tr", null,
                        React.createElement("th", null, t.stampDuty),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(totalTax)))),
                    React.createElement("tr", null,
                        React.createElement("th", null, t.commission),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(commission)))),
                    React.createElement("tr", null,
                        React.createElement("th", null, t.legal),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(legalAmount))))),
                React.createElement("tfoot", { className: "c-amortize__foot" },
                    React.createElement("tr", null,
                        React.createElement("th", null, t.totalExpenses),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(totalExpenses))))))),
        React.createElement("div", { className: "l-pad l-pad--2" },
            React.createElement("table", { className: "c-amortize__table l-pad l-pad--2" },
                React.createElement("thead", { className: "c-amortize__head c-amortize__head--light" },
                    React.createElement("tr", null,
                        React.createElement("th", { colSpan: 2 }, t.initialTotalCashOutlay))),
                React.createElement("tbody", { className: "c-amortize__body" },
                    React.createElement("tr", null,
                        React.createElement("th", null, t.downPayment),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(downPayment)))),
                    React.createElement("tr", null,
                        React.createElement("th", null, t.stampDuty),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(totalTax)))),
                    insurance ? (React.createElement("tr", null,
                        React.createElement("th", null, t.insurance),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(insurance))))) : null,
                    React.createElement("tr", null,
                        React.createElement("th", null, t.commission),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(commission)))),
                    React.createElement("tr", null,
                        React.createElement("th", null, t.legal),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(legalAmount))))),
                React.createElement("tfoot", { className: "c-amortize__foot" },
                    React.createElement("tr", null,
                        React.createElement("th", null, t.totalCashOutlay),
                        React.createElement("td", null, format_1.default.currencyFull(Math.ceil(totalCashOutlay)))))))));
};
exports.renderError = function (error, t, inputs) {
    if (inputs === void 0) { inputs = null; }
    return (React.createElement("div", { className: "c-mortgage__error" },
        React.createElement("div", { className: "c-mortgage__error-title" }, t.error),
        React.createElement("div", { className: "c-mortgage__error-caption" }, errorToString_1.errorToString(error, t, inputs))));
};
exports.renderRowError = function (error, t, inputs) {
    if (inputs === void 0) { inputs = null; }
    return (React.createElement("div", { className: "c-forms__responses" },
        React.createElement("div", { className: "c-forms__response--hint" }),
        React.createElement("div", { className: "c-forms__response--error" },
            React.createElement("span", { className: "fal fa-info-circle" }),
            " ",
            errorToString_1.errorToString(error, t, inputs))));
};
exports.renderSchedule = function (schedule, t) {
    var yearlyTable = [];
    schedule.map(function (it, i) {
        var year = Math.floor(i / 12);
        if (!yearlyTable[year]) {
            yearlyTable[year] = [];
        }
        yearlyTable[year].push(it);
    });
    var renderTable = function (yearlyTable, i) {
        var renderTableRow = function (r, k) {
            return (React.createElement("tr", null,
                React.createElement("td", null, i * 12 + k + 1),
                React.createElement("td", null, format_1.default.comma(Math.ceil(r.payment))),
                React.createElement("td", null, format_1.default.comma(Math.ceil(r.principle))),
                React.createElement("td", null, format_1.default.comma(Math.ceil(r.interest))),
                React.createElement("td", null, format_1.default.comma(Math.ceil(r.balance)))));
        };
        return (React.createElement("table", { className: "c-amortize__table" },
            React.createElement("thead", { className: "c-amortize__head" },
                React.createElement("tr", null,
                    React.createElement("td", { colSpan: 5 },
                        t.year,
                        " ",
                        i + 1)),
                React.createElement("tr", null,
                    React.createElement("th", null, t.noMonth),
                    React.createElement("th", null, t.payment),
                    React.createElement("th", null, t.principle),
                    React.createElement("th", null, t.interest),
                    React.createElement("th", null, t.balance))),
            React.createElement("tbody", { className: "c-amortize__body" }, yearlyTable.map(renderTableRow))));
    };
    return yearlyTable.map(renderTable);
};
exports.renderRateTable = function (rateTable, t) {
    var renderRateRow = function (row, i) {
        var renderRateByYear = function (byYear) {
            return (React.createElement("td", null, format_1.default.comma(Math.ceil(byYear.payment))));
        };
        return (React.createElement("tr", { key: i },
            React.createElement("td", null, row.rate),
            row.byYears.map(renderRateByYear)));
    };
    var renderRateByYearHead = function (byYear) { return (React.createElement("th", null,
        byYear.year,
        " ",
        t.years)); };
    return (React.createElement("div", { className: "c-mortgage__body c-mortgage__body--active" },
        React.createElement("table", { className: "c-amortize__table" },
            React.createElement("thead", { className: "c-amortize__head" },
                React.createElement("tr", null,
                    React.createElement("th", null,
                        t.interestRate,
                        " (%)"),
                    rateTable[0].byYears.map(renderRateByYearHead))),
            React.createElement("tbody", { className: "c-amortize__body" }, rateTable.map(renderRateRow)))));
};
exports.renderSearchCard = function (props, lang) {
    if (!props.propertyValue)
        return null;
    var getSearchRange = function (price, ranges) {
        var from = ranges.from[0];
        var index = ranges.from.findIndex(function (it) { return price < it; });
        from = index === -1 ? ranges.from[ranges.from.length - 1] : ranges.from[index - 1];
        var to = index === -1 ? ranges.to[ranges.to.length - 1] : ranges.to[index - 1];
        return { from: from, to: to };
    };
    var searchRange = getSearchRange(props.propertyValue, props.searchForSaleRanges);
    var getSearchRangeText = function (range, t) { return "" + (range.from ? format_1.default.currency(range.from, 'HK$') : "<") + (range.to === -1 ? '+' : (range.from ? ' - ' + format_1.default.currency(range.to) : format_1.default.currency(range.to))); };
    var getSearchPriceRange = function (range, t) { return "price-" + (range.from === 0 ? t.below + "-" + range.to : (range.to === -1 ? t.above + "-" + range.to : range.from + "-" + range.to)) + "-hkd"; };
    var searchRangeText = getSearchRangeText(searchRange, props.t);
    var searchPriceRange = getSearchPriceRange(searchRange, props.t);
    return (React.createElement("div", { className: "c-calcfull__cta" },
        React.createElement("div", { className: "c-calcfull__cta-main" },
            React.createElement("h2", { className: "c-calcfull__cta-title" },
                props.t.searchTitle,
                " ",
                searchRangeText,
                "?"),
            React.createElement("div", { className: "c-calcfull__cta-cta" },
                React.createElement("a", { href: "/" + lang + "/property-search/buy/" + searchPriceRange, className: "o-btn o-btn--long o-btn--primary" },
                    props.t.view,
                    " ",
                    searchRangeText,
                    " ",
                    props.t.listings,
                    "\u00A0"))),
        React.createElement("div", { className: "c-calcfull__cta-img" },
            React.createElement("img", { src: "/res/img/404.jpg", alt: "" }))));
};
exports.renderArticles = function (props, onToggle) {
    if (!props.articles || !props.articles.length)
        return null;
    var renderArticle = function (article, i) {
        var rowClass = classnames_1.default(['c-calctips__row', { 'c-calctips__row--active': i === props.articleActiveIndex }]);
        return (React.createElement("div", { id: "article-" + i, className: rowClass },
            React.createElement("h3", { onClick: function () { return onToggle(i); }, className: "c-calctips__title" }, article.title),
            React.createElement("div", { className: "c-calctips__body", dangerouslySetInnerHTML: { __html: article.body } })));
    };
    return (React.createElement("div", { className: "c-calctips" },
        React.createElement("h2", { className: "c-calctips__header" }, props.t.learnMoreAboutMortgage),
        props.articles.map(renderArticle)));
};
